<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li>
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          Report Redeemption History
        </li>
        
      </ol>
      <div class="row">
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
               <label for="searchbox">Search</label>
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
                name="searchbox"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="from">From Month</label>
          <datepicker :minimumView="'month'"   :name="'from'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="fromDateSelect" ></datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="To">To Month</label>
          <datepicker :minimumView="'month'" :value="newLastMonthDate"  :name="'To'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="toDateSelect" ></datepicker>
          </div>
        </div>
         <div class="col-md-3">
          <div class="form-group">
            <label for="To">Partner Type</label>
          <v-select v-model="PartnerTypeSelected" :options="PartnerOptions" :reduce="partnerDetails => partnerDetails.code" label="name" />
          </div>
        </div>
      </div>
      <div class="row">
       
        <div class="col-md-3">
          <div class="form-group">
            <label for="Status">Status</label>
          <v-select v-model="StatusSelected" :options="StatusOptions" :reduce="statusDetails => statusDetails.code" label="name" />
          </div>
        </div>
      </div>
        <div class="row">
        <div class="col-md-2 col-md-offset-7">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Filter
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="exportReport(0)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Export To CSV
            </button>
          </div>
        </div>
      </div>
      <div class="row">
       
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer Code</th>
                    <th>Partner</th>
                    <th>Transaction Id</th>
                    <th>On Redeemption Total Point</th>
                    <th>Redeemption Points</th>
                    <th>Balance Points</th>
                    <th>Status</th>
                    <th>Request Date</th>
                    <th>PATID</th>
                    <th>Action Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in redeemption_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    
                    <td>{{ item.UserCode }}</td>
                    <td>{{ item.PartnerType }}</td>
                    <td>{{ item.TransactionId }}</td>
                    <td>{{ item.OnRequestTotalPoints }}</td>
                    <td>{{ item.RedeempRequestPoints }}</td>
                    <td>{{ item.OnRequestTotalPoints - item.RedeempRequestPoints  }}</td>
                    <td>{{ item.status }}</td>
                    <td>{{ item.requestOn | dateFormatReadable }}</td>
                    <td>{{ item.TransactionProcessId }}</td>
                    <td>{{ item.actionOn | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../services/common-services';
import Datepicker from 'vuejs-datepicker';
import DateLanguages from './components/utils/DateLanguages';
import moment from 'moment'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
  name: 'ScanCouponDetails',
  data() {
    return {
      redeemption_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      newLastMonthDate:'',
      fromMonthYear: null,
      toMonthYear: null,
      PartnerOptions: [
      {code: 'Retailer','name':'Retailer'},
      {code: 'Reborer','name':'Reborer'},
      {code: 'Grinder','name':'Grinder'},
      {code: 'ReborerPlusGrinder','name':'Reborer Plus Grinder'},
      {code: 'Mechanics','name':'Mechanics'},
      ],
      StatusOptions: [
      {code: '','name':'ALL'},
      {code: 'RequestOpen','name':'Request Open'},
      {code: 'InProcess','name':'In Process'},
      {code: 'Completed','name':'Completed'},
      {code: 'Settled','name':'Settled'},
      {code: 'RejectRequest','name':'Reject Request'},
      {code: 'Processed','name':'Processed'},
      
      ],
      PartnerTypeSelected:'',
      StatusSelected:''
    };
  },
  components: {
    Paginate,
    Datepicker,
    DateLanguages,
    vSelect
  },
  methods: {
    fromDateSelect(date){
      this.fromMonthYear =date
    },
    toDateSelect(date){
      this.newLastMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toMonthYear =this.newLastMonthDate;
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      
      // Always include filter parameters (empty string means no filter)
      params['PartnerTypeSelected'] = this.PartnerTypeSelected || '';
      params['StatusSelected'] = this.StatusSelected || '';
      
      if (this.fromMonthYear) {
        params['fromMonthYear'] = this.fromMonthYear;
      }
      if (this.toMonthYear) {
        params['toMonthYear'] = this.toMonthYear;
      }
      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
     exportReport(pageNum){
      let loader = this.$loading.show();
      
      // Create clean params object for export
      const params = {};
      
      // Only add parameters that have actual values (skip empty strings)
      if (this.PartnerTypeSelected && this.PartnerTypeSelected !== '') {
        params['PartnerTypeSelected'] = this.PartnerTypeSelected;
      }
      
      // Handle status filtering - only include if not "ALL"
      if (this.StatusSelected && this.StatusSelected !== '') {
        params['StatusSelected'] = this.StatusSelected;
      }
      
      if (this.fromMonthYear) {
        params['fromMonthYear'] = this.fromMonthYear;
      }
      if (this.toMonthYear) {
        params['toMonthYear'] = this.toMonthYear;
      }
      if (this.searchText && this.searchText.trim() !== '') {
        params['searchText'] = this.searchText.trim();
      }
      
      // Don't include pagination for export - we want all filtered results
      // params['page'] and params['size'] are intentionally omitted for full export
      
      console.log('Export params:', params); // Debug log to verify parameters
      
      commonServices
        .get('kspgAPI/CouponRedeemption/historyListReportExport', params)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          
          // Generate filename with current date and filters
          const dateStr = new Date().toISOString().split('T')[0];
          const statusStr = this.StatusSelected || 'ALL';
          const partnerStr = this.PartnerTypeSelected || 'ALL';
          fileLink.setAttribute('download', `redemption_report.csv`);
          
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        })
        .catch((e) => {
           if(e.response && e.response.data && e.response.data.error == "Invalid API key "){
             loader.hide();
             this.$router.push({ name: 'login'});
          } else {
            console.error('Export error:', e);
            alert('Error exporting data. Please check your filters and try again.');
          }
        })
        .finally(() => {
          setTimeout(() => {loader.hide()}, 1000);
        });
    },
    getAllCoupons(pageNum) {
      let loader = this.$loading.show();
      // this.skyloStart(50);
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/CouponRedeemption/historyListReport', params)
        .then((response) => {
          const {
            redeemption_data,
            totalItems,
            currentPage,
            TotalPage,
            AvailableCoupon,
            GeneratedCoupon,
            TotalCoupon
          } = response.data;
          this.redeemption_data = redeemption_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon =  AvailableCoupon;
          this.GeneratedCoupon =   GeneratedCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
      // this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },
   
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align{
    text-align: left !important;
}
</style>